import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { SharedService } from '../services/shared-service';
import { filter, map, Observable } from 'rxjs';

export const AccessGuard: CanActivateFn = (route, state): Observable<boolean> => {
  // Inject the required service
  const sharedService = inject(SharedService);

  return sharedService.appInitialized$.pipe(
    filter((initialized) => initialized), // Wait for appInitialized$ to emit true
    map(() => !sharedService.AccessDenied) // Allow route activation
  );
};